import ILSAnalyticsTenderReportsComponent from '../components';

const ILSAnalyticsTenderReportsContainer = () => {
  return <ILSAnalyticsTenderReportsComponent />;
};

export default ILSAnalyticsTenderReportsContainer;
